import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Input, Button, VStack, HStack, Box, Text, ModalFooter, useColorMode } from '@chakra-ui/react';
import { colors } from './constants';
import { ColumnModalProps } from './types';

const ColumnModal = ({
  isOpen,
  onClose,
  columnName,
  columnColor,
  setColumnName,
  setColumnColor,
  onAddColumn,
  isEditing = false,
}: ColumnModalProps) => {
  const { colorMode } = useColorMode();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent p={4}>
        <ModalHeader>
          {isEditing ? 'Edit column' : 'Add column'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={6} align="stretch">
            <Box>
              <Text mb={2} fontSize="sm">Name</Text>
              <Input
                placeholder="Name"
                value={columnName}
                onChange={(e) => setColumnName(e.target.value)}
              />
            </Box>

            <Box>
              <Text mb={3} fontSize="sm">Color</Text>
              <HStack spacing={3} wrap="wrap">
                {Object.entries(colors[colorMode]).map(([key, scheme]) => (
                  <Box
                    key={key}
                    as="button"
                    w="24px"
                    h="24px"
                    borderRadius="full"
                    bg={scheme.tagBackground}
                    onClick={() => setColumnColor(key)}
                    border="2px solid"
                    borderColor={columnColor === key ? scheme.placeholderText : "transparent"}
                    _hover={{ transform: 'scale(1.1)' }}
                    transition="all 0.2s"
                  />
                ))}
              </HStack>
            </Box>

          </VStack>
        </ModalBody>
        <ModalFooter px={0} pb={0}>
          <HStack justify="space-between" width="100%">
            <Button
              variant="ghost"
              onClick={onClose}
              textDecoration="underline"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={onAddColumn}
            >
              Confirm
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
};

export default ColumnModal;